<div class="close">
  <button mat-dialog-close>
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">选择不可用订阅的补偿计划</div>
<div class="content" mat-dialog-content>
  <div class="txt1">
    如您不满意其他方案方案，您也可以选择退款至环球巴士钱包余额。
  </div>
  <div class="txt1">我们将为您提供以下支持:</div>
  <div class="txt2">
    1、按照当前订阅剩余价值，将相应金额退还至您的环球巴士钱包
  </div>
  <div class="txt2">
    2、钱包余额可与其他支付方式组合使用(支持混合支付)，
    可用于续费当前服务或选购其他类型订阅。 不支持提现
  </div>

  <div class="detail">
    <div class="imgs">
      <img src="../../../../assets/images/compensate/netflix.webp" alt="" />
      <img src="../../../../assets/images/compensate/change.webp" alt="" />
      <span class="huiyuan">
        <img
          src="../../../../assets/images/compensate/wallet.webp"
          alt=""
          class="huiyuan"
        />我的钱包
      </span>
    </div>
    <div class="item">
      <span class="left">过期时间：</span>
      <span class="right"
        ><app-datetime [text]="data.ended_time"></app-datetime
      ></span>
    </div>
    <div class="item">
      <span class="left">转化金额：</span
      ><span class="right">{{ amount }}元</span>
    </div>
  </div>
</div>
<div class="button">
  <button
    matRipple
    style="background: #00ad9d"
    [disabled]="loading"
    (click)="refund()"
  >
    确认退款
  </button>
</div>
